import { render, staticRenderFns } from "./Auditors.vue?vue&type=template&id=3a60051a&scoped=true"
import script from "./Auditors.vue?vue&type=script&lang=js"
export * from "./Auditors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a60051a",
  null
  
)

export default component.exports